import React, { FC } from 'react';
import { observer } from 'mobx-react';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

import { StepComponents } from 'kioskApp/containers';
import { useStore } from 'kioskApp/hooks';

const useStyles = makeStyles((theme: Theme) => {
    return {
        body: {
            height: 'calc(100vh)',
            overflow: 'auto',
            background: theme.palette.background.default,
        },
    };
});

export const PaymentKioskPage: FC = observer(() => {
    const { wizard } = useStore();
    const classes = useStyles();

    return (
        <div className={classes.body}>
            {StepComponents[wizard.currentStep.name]}
        </div>
    );
});
